import axios from '@/api/client';

const state = {
  // ALT (kannst du behalten, aber für parallel nicht mehr ideal)
  stockhistories: null,
  stockhistory: null,
  stocksignals: null,
  preisdeltas: [],
  preisdeltasAll: [],

  // ✅ NEU: parallel-safe Caches pro Stock-ID
  stockhistoriesById: {}, // { [idstocks]: histories[] }
  stocksignalsById: {},   // { [idstocks]: signals }
  preisdeltasById: {},    // optional
    // ✅ NEU: daily cache
  stockhistoriesDailyById: {}, // { [idstocks]: dailyRows[] }
};

const getters = {
  // ALT
  stateStockhistories: state => state.stockhistories,
  statePreisdeltas: state => state.preisdeltas,
  statePreisdeltasAll: state => state.preisdeltasAll,
  stateStockhistory: state => state.stockhistory,
  stateStocksignals: state => state.stocksignals,
  getStockhistoriesById: (state) => (idstocks) => state.stockhistoriesById[idstocks] || null,
  getStocksignalsById: (state) => (idstocks) => state.stocksignalsById[idstocks] || null,
  getPreisdeltasById: (state) => (idstocks) => state.preisdeltasById[idstocks] || null,
// ✅ NEU
  getStockhistoriesDailyById: (state) => (idstocks) => state.stockhistoriesDailyById[idstocks] || null,
};

const actions = {
  async createStockhistory({ dispatch }, stockhistory) {
    await axios.post('stockhistories', stockhistory);
    await dispatch('getStockhistories'); // falls du das wirklich brauchst (ohne payload)
  },

  /**
   * ✅ WICHTIG:
   * - payload ist z.B. [39] oder [39, 40, 41]
   * - action RETURNt die Daten => component kann parallel arbeiten
   * - zusätzlich speichern wir optional pro ID im Cache
   */
  async getStockhistories({ commit }, payload) {
    // Schutz, falls payload fehlt
    const ids = Array.isArray(payload) ? payload : (payload ? [payload] : []);

    const { data } = await axios.post('gettrend', ids);

    // ✅ Cache pro ID (empfohlen)
    // Annahme: data enthält histories gemischt für alle ids, und jedes history-item hat z.B. "idstocks" / "stocks_idstocks" o.ä.
    // Wenn deine API NUR 1 Stock pro Request liefert (wie bisher), ist es trivial:
    if (ids.length === 1) {
      commit('setStockhistoriesById', { idstocks: ids[0], histories: data });
    }

    // (Optional) alter globaler state – nur wenn du den noch irgendwo brauchst
    commit('setStockhistories', data);

    return data;
  },

  /**
   * ✅ NEU: DAILY Daten (für Zoom lastMonth)
   * payload: { ids: [119] oder [111,112], days: 31 }
   */
    async getStockhistoriesDaily({ commit }, payload) {
      const ids = Array.isArray(payload?.ids) ? payload.ids : [];
      const days = Number(payload?.days ?? 31);

      if (!ids.length) return [];

      const { data } = await axios.post(`getStockhistoriesDaily?days=${days}`, ids);

      // optional: global state setzen, falls du es im component über stateStockhistories nutzt
      commit("setStockhistories", data);

      return data;
    },


    async getPreisdeltas({ commit }, payload) {
      const ids = Array.isArray(payload) ? payload : (payload ? [payload] : []);
      const { data } = await axios.post('deltapreis', ids);

      if (ids.length === 1) {
        commit('setPreisdeltasById', { idstocks: ids[0], preisdeltas: data });
      }

      commit('setPreisdeltas', data);  // ✅ WIEDER AN
      return data;
    },

  /**
   * ✅ Parallel-safe wie getStockhistories
   */
  async getPreisdeltasAll({ commit }) {
    const { data } = await axios.get('deltapreis/all');
    commit('setPreisdeltasAll', Array.isArray(data) ? data : []);
    return data;
  },

  async getSignale({ commit }, payload) {
  const ids = Array.isArray(payload) ? payload : (payload ? [payload] : []);
  try {
    const res = await axios.post('signale', ids);
    const data = res?.data ?? null;

    if (ids.length === 1) {
      commit('setSignalsById', { idstocks: ids[0], signals: data });
    }

    // commit('setSignals', data);
    return data;
  } catch (err) {
    console.error('getSignale failed:', { ids, err });

    if (ids.length === 1) {
      commit('setSignalsById', { idstocks: ids[0], signals: null });
    }

    return null;
  }
},

  async viewStockhistory({ commit }, id) {
    console.log('stockhistories.js: viewStockhistory:', id);
    const { data } = await axios.get(`stockshistory/${id}`);
    commit('setStockhistories', data);
    return data;
  },

  // eslint-disable-next-line no-empty-pattern
  async updateStockhistory({}, stockhistory) {
    await axios.patch(`stockhistory/${stockhistory.id}`, stockhistory.form);
  },

  // eslint-disable-next-line no-empty-pattern
  async deleteStockhistory({}, id) {
    await axios.delete(`stockhistory/${id}`);
  }
};

const mutations = {
  // ALT
  setStockhistories(state, stockhistories) {
    state.stockhistories = stockhistories;
  },
  setPreisdeltas(state, preisdeltas) {
    state.preisdeltas = preisdeltas;
  },
  setPreisdeltasAll(state, preisdeltasAll) {
    state.preisdeltasAll = preisdeltasAll;
  },
  setStockhistory(state, stockhistory) {
    state.stockhistory = stockhistory;
  },
  setSignals(state, stocksignals) {
    state.stocksignals = stocksignals;
  },

  // ✅ NEU: parallel-safe caches
  setStockhistoriesById(state, { idstocks, histories }) {
    state.stockhistoriesById = {
      ...state.stockhistoriesById,
      [idstocks]: histories,
    };
  },

  setStockhistoriesDailyById(state, { idstocks, histories }) {
    state.stockhistoriesDailyById = {
      ...state.stockhistoriesDailyById,
      [idstocks]: histories,
    };
  },


  setSignalsById(state, { idstocks, signals }) {
    state.stocksignalsById = {
      ...state.stocksignalsById,
      [idstocks]: signals,
    };
  },

  setPreisdeltasById(state, { idstocks, preisdeltas }) {
    state.preisdeltasById = {
      ...state.preisdeltasById,
      [idstocks]: preisdeltas,
    };
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
